
import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { IssueCreateIssuesTasksDirectiveController } from './issue-create-issues-tasks.directive.controller'
import { IUserSession } from '../../../helpers/user-session'

//#region Asset Imports

import './issue-create-issues-tasks.scss'
import * as TEMPLATE from './issue-create-issues-tasks.tpl.html'

//#endregion

export class IssueCreateIssuesTasksDirective implements ng.IDirective {
    restrict = 'E'
    scope = {
        id: '='
    }

    controller = ['$scope', '$q', '$element', '$timeout', 'api', 'logger', 'localDictionary', 'userSession',
        ($scope, $q: ng.IQService, $element: JQuery, $timeout: ng.ITimeoutService, api: Api, logger: LoggerService, localDictionary: LocalDictionaryFactory, userSession: IUserSession) => {
            return new IssueCreateIssuesTasksDirectiveController($scope, $q, $element, $timeout, api, logger, localDictionary, userSession)
        }
    ]

    template = TEMPLATE
}